/** Updates are offered explicitly; an open financial form is never reloaded. */
type UpdateState = { available: boolean; checking: boolean; message: string }
let state:UpdateState={available:false,checking:false,message:''}
let registration:ServiceWorkerRegistration | null=null
let reloading=false
const listeners=new Set<() => void>()
const publish=(patch:Partial<UpdateState>)=>{state={...state,...patch};listeners.forEach(fn=>fn())}
export const getPwaUpdateState=()=>state
export const subscribePwaUpdate=(fn:()=>void)=>{listeners.add(fn);return()=>{listeners.delete(fn)}}

export async function checkPwaUpdate() {
  if(!registration) { publish({message:navigator.onLine?'A verificação estará disponível após carregar o aplicativo.':'Conecte-se à internet para verificar atualizações.'}); return }
  publish({checking:true,message:''})
  try {
    await registration.update()
    publish({available:!!registration.waiting,message:registration.waiting?'Nova versão pronta para instalar.':registration.installing?'Verificando e preparando a nova versão…':'Nenhuma atualização pendente.'})
  } catch { publish({message:'Não foi possível verificar agora. Tente novamente quando estiver conectado.'}) }
  finally { publish({checking:false}) }
}

export async function applyPwaUpdate() {
  if(document.querySelector('[role="dialog"], .modal-open, .confirm-dialog-backdrop')) throw new Error('Conclua ou cancele a edição aberta antes de atualizar.')
  const worker=registration?.waiting
  if(!worker) {publish({available:false});return}
  // The worker also refuses activation while another app window is open.
  await new Promise<void>((resolve,reject)=>{
    const channel=new MessageChannel()
    const timer=window.setTimeout(()=>{channel.port1.close();reloading=false;reject(new Error('A atualização não respondeu. Tente novamente.'))},8000)
    channel.port1.onmessage=event=>{
      window.clearTimeout(timer);channel.port1.close()
      if(!event.data?.ok){reloading=false;reject(new Error(event.data?.error || 'Feche as outras abas do sistema antes de atualizar.'));return}
      resolve()
    }
    reloading=true
    worker.postMessage({type:'APPLY_UPDATE'},[channel.port2])
  })
}

export function registrarPWA() {
  if(!import.meta.env.PROD || !('serviceWorker' in navigator))return
  navigator.serviceWorker.addEventListener('controllerchange',()=>{if(reloading){reloading=false;window.location.reload()}})
  const start=async()=>{
    try {
      registration=await navigator.serviceWorker.register('/sw.js',{scope:'/',updateViaCache:'none'})
      const watch=()=>{
        const installing=registration?.installing
        installing?.addEventListener('statechange',()=>{
          if(installing.state==='installed' && navigator.serviceWorker.controller)publish({available:true,message:'Nova versão pronta para instalar.'})
        })
      }
      registration.addEventListener('updatefound',watch);watch()
      publish({available:!!registration.waiting})
      void checkPwaUpdate()
      const timer=window.setInterval(()=>void checkPwaUpdate(),60*60*1000)
      document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')void checkPwaUpdate()})
      window.addEventListener('beforeunload',()=>window.clearInterval(timer),{once:true})
    } catch { publish({message:'Não foi possível preparar a atualização do aplicativo.'}) }
  }
  if(document.readyState==='complete')void start()
  else window.addEventListener('load',()=>void start(),{once:true})
}
